module.exports = __webpack_public_path__ + "img/9788936456764.da7c17bb.jpg";